import { css, useTheme } from '@emotion/react';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import { customProperties, designTokens } from '@commercetools-uikit/design-system';
import _pt from 'prop-types';
import { useRef, useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import FlatButton from '@commercetools-uikit/flat-button';
import { WorldIcon } from '@commercetools-uikit/icons';
import { jsx } from '@emotion/react/jsx-runtime';
import TextareaAutosize from 'react-textarea-autosize';
import { warning, filterDataAttributes } from '@commercetools-uikit/utils';
var messages$1 = defineMessages({
  missingRequiredField: {
    id: 'UIKit.LocalizedTextInput.missingRequiredField',
    description: 'Error message for missing required value',
    defaultMessage: 'This field is required. Provide at least one value.'
  },
  show: {
    id: 'UIKit.LocalizedTextInput.show',
    description: 'Label of language expansion button',
    defaultMessage: 'Show all languages ({remainingLanguages})'
  },
  hide: {
    id: 'UIKit.LocalizedTextInput.hide',
    description: 'Label of language collapse button',
    defaultMessage: 'Hide languages ({remainingLanguages})'
  }
});
var defaultProps = {
  hideMessage: messages$1.hide,
  showMessage: messages$1.show
};

var LocalizedInputToggle = function LocalizedInputToggle(props) {
  var intl = useIntl();
  var labelMessage = props.isOpen ? props.hideMessage : props.showMessage;
  var label = typeof labelMessage === 'string' ? labelMessage : intl.formatMessage(labelMessage, {
    remainingLanguages: props.remainingLocalizations
  });
  return jsx(FlatButton, {
    icon: props.icon ? props.icon : jsx(WorldIcon, {}),
    label: label,
    onClick: props.onClick,
    isDisabled: props.isDisabled
  });
};

LocalizedInputToggle.propTypes = process.env.NODE_ENV !== "production" ? {
  icon: _pt.element,
  isOpen: _pt.bool,
  onClick: _pt.func.isRequired,
  isDisabled: _pt.bool,
  showMessage: _pt.oneOfType([_pt.string, _pt.any]).isRequired,
  hideMessage: _pt.oneOfType([_pt.string, _pt.any]).isRequired,
  remainingLocalizations: _pt.number
} : {};
LocalizedInputToggle.defaultProps = defaultProps;
LocalizedInputToggle.displayName = 'LocalizedInputToggle';
var LocalizedInputToggle$1 = LocalizedInputToggle;

function ownKeys$1(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context;

      _forEachInstanceProperty(_context = ownKeys$1(Object(source), true)).call(_context, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context2;

      _forEachInstanceProperty(_context2 = ownKeys$1(Object(source))).call(_context2, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var getInputBorderColor = function getInputBorderColor(vars, props) {
  if (props.isDisabled || props.disabled) {
    return vars[designTokens.borderColorForInputWhenDisabled];
  }

  if (props.hasError) {
    return vars[designTokens.borderColorForInputWhenError];
  }

  if (props.hasWarning) {
    return vars[designTokens.borderColorForInputWhenWarning];
  }

  if (props.isReadOnly || props.readOnly) {
    return vars[designTokens.borderColorForInputWhenReadonly];
  }

  return vars[designTokens.borderColorForInput];
};

var getInputFontColor = function getInputFontColor(vars, props) {
  if (props.isDisabled || props.disabled) {
    return vars[designTokens.fontColorForInputWhenDisabled];
  }

  if (props.hasError) {
    return vars[designTokens.fontColorForInputWhenError];
  }

  if (props.hasWarning) {
    return vars[designTokens.fontColorForInputWhenWarning];
  }

  if (props.isReadOnly || props.readOnly) {
    return vars[designTokens.fontColorForInputWhenReadonly];
  }

  return vars[designTokens.fontColorForInput];
};

var getInputStyles = function getInputStyles(props, theme) {
  var vars = _objectSpread$1(_objectSpread$1({}, customProperties), theme);

  return /*#__PURE__*/css("appearance:none;background-color:", props.isDisabled || props.disabled ? vars[designTokens.backgroundColorForInputWhenDisabled] : vars[designTokens.backgroundColorForInput], ";border:1px solid ", getInputBorderColor(vars, props), ";border-radius:", vars[designTokens.borderRadiusForInput], ";box-sizing:border-box;color:", getInputFontColor(vars, props), ";cursor:", props.isDisabled ? 'not-allowed' : 'default', ";display:flex;flex:1;font-family:inherit;font-size:", vars[designTokens.fontSizeForInput], ";height:", vars.sizeHeightInput, ";min-height:", vars.sizeHeightInput, ";opacity:", props.isDisabled || props.disabled ? '1' : 'unset', ";outline:none;overflow:hidden;padding:0 ", vars.spacingS, ";transition:border-color ", vars.transitionStandard, ",background-color ", vars.transitionStandard, ",color ", vars.transitionStandard, ",box-shadow ", vars.transitionStandard, ";width:100%;&::placeholder{color:", vars[designTokens.placeholderFontColorForInput], ";}:active,:focus,:hover:not(:disabled):not(:read-only){border-color:", vars[designTokens.borderColorForInputWhenFocused], ";}:focus{box-shadow:inset 0 0 0 2px ", vars[designTokens.borderColorForInputWhenFocused], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:getInputStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
}; // eslint-disable-next-line import/prefer-default-export

/* we need this line-height to achieve 32px height when the component has only one row */


var sizeInputLineHeight = '22px'; // NOTE: order is important here
// * a disabled-field currently does not display warning/error-states so it takes precedence
// * a readonly-field cannot be changed, but it might be relevant for validation, so error and warning are checked first
// how you can interact with the field is controlled separately by the props, this only influences visuals

var getTextareaStyles = function getTextareaStyles(props, theme) {
  var baseStyles = [getInputStyles(props, theme), /*#__PURE__*/css("padding:", customProperties.spacingXs, " ", customProperties.spacingS, ";line-height:", sizeInputLineHeight, ";flex:auto;word-break:break-all;white-space:pre-wrap;resize:vertical;" + (process.env.NODE_ENV === "production" ? "" : ";label:baseStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm11bHRpbGluZS1pbnB1dC5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0JPIiwiZmlsZSI6Im11bHRpbGluZS1pbnB1dC5zdHlsZXMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgY3VzdG9tUHJvcGVydGllcyBhcyB2YXJzIH0gZnJvbSAnQGNvbW1lcmNldG9vbHMtdWlraXQvZGVzaWduLXN5c3RlbSc7XG5pbXBvcnQgeyBnZXRJbnB1dFN0eWxlcyB9IGZyb20gJy4uL3N0eWxlcyc7XG5pbXBvcnQgdHlwZSB7IFRNdWx0aUxpbmVJbnB1dFByb3BzIH0gZnJvbSAnLi9tdWx0aWxpbmUtaW5wdXQnO1xuXG4vKiB3ZSBuZWVkIHRoaXMgbGluZS1oZWlnaHQgdG8gYWNoaWV2ZSAzMnB4IGhlaWdodCB3aGVuIHRoZSBjb21wb25lbnQgaGFzIG9ubHkgb25lIHJvdyAqL1xuY29uc3Qgc2l6ZUlucHV0TGluZUhlaWdodCA9ICcyMnB4JztcblxuLy8gTk9URTogb3JkZXIgaXMgaW1wb3J0YW50IGhlcmVcbi8vICogYSBkaXNhYmxlZC1maWVsZCBjdXJyZW50bHkgZG9lcyBub3QgZGlzcGxheSB3YXJuaW5nL2Vycm9yLXN0YXRlcyBzbyBpdCB0YWtlcyBwcmVjZWRlbmNlXG4vLyAqIGEgcmVhZG9ubHktZmllbGQgY2Fubm90IGJlIGNoYW5nZWQsIGJ1dCBpdCBtaWdodCBiZSByZWxldmFudCBmb3IgdmFsaWRhdGlvbiwgc28gZXJyb3IgYW5kIHdhcm5pbmcgYXJlIGNoZWNrZWQgZmlyc3Rcbi8vIGhvdyB5b3UgY2FuIGludGVyYWN0IHdpdGggdGhlIGZpZWxkIGlzIGNvbnRyb2xsZWQgc2VwYXJhdGVseSBieSB0aGUgcHJvcHMsIHRoaXMgb25seSBpbmZsdWVuY2VzIHZpc3VhbHNcbmNvbnN0IGdldFRleHRhcmVhU3R5bGVzID0gKHByb3BzOiBUTXVsdGlMaW5lSW5wdXRQcm9wcywgdGhlbWU6IFRoZW1lKSA9PiB7XG4gIGNvbnN0IGJhc2VTdHlsZXMgPSBbXG4gICAgZ2V0SW5wdXRTdHlsZXMocHJvcHMsIHRoZW1lKSxcbiAgICBjc3NgXG4gICAgICBwYWRkaW5nOiAke3ZhcnMuc3BhY2luZ1hzfSAke3ZhcnMuc3BhY2luZ1N9O1xuICAgICAgbGluZS1oZWlnaHQ6ICR7c2l6ZUlucHV0TGluZUhlaWdodH07XG4gICAgICBmbGV4OiBhdXRvO1xuICAgICAgd29yZC1icmVhazogYnJlYWstYWxsO1xuICAgICAgd2hpdGUtc3BhY2U6IHByZS13cmFwO1xuICAgICAgcmVzaXplOiB2ZXJ0aWNhbDtcbiAgICBgLFxuICBdO1xuICByZXR1cm4gYmFzZVN0eWxlcztcbn07XG5cbi8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBpbXBvcnQvcHJlZmVyLWRlZmF1bHQtZXhwb3J0XG5leHBvcnQgeyBnZXRUZXh0YXJlYVN0eWxlcyB9O1xuIl19 */")];
  return baseStyles;
}; // eslint-disable-next-line import/prefer-default-export


function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context;

      _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context2;

      _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var MIN_ROW_COUNT = 1;

var MultilineInput = function MultilineInput(props) {
  var theme = useTheme();
  var onHeightChange = props.onHeightChange;
  var ref = useRef(null);
  var handleHeightChange = useCallback(function (height, meta) {
    var _ref$current;

    var rowCount = Math.floor(((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollHeight) || 0 / meta.rowHeight);

    if (onHeightChange) {
      onHeightChange(height, rowCount);
    }
  }, [ref, onHeightChange]);

  if (!props.isReadOnly) {
    process.env.NODE_ENV !== "production" ? warning(typeof props.onChange === 'function', 'MultilineInput: "onChange" is required when is not read only.') : void 0;
  }

  return jsx(TextareaAutosize, _objectSpread({
    ref: ref,
    name: props.name,
    onHeightChange: handleHeightChange,
    autoComplete: props.autoComplete,
    value: props.value,
    onChange: props.onChange,
    id: props.id,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    disabled: props.isDisabled,
    placeholder: props.placeholder,
    readOnly: props.isReadOnly,
    autoFocus: props.isAutofocussed,
    css: getTextareaStyles(props, theme) // Allow to override the styles by passing a `className` prop.
    // Custom styles can also be passed using the `css` prop from emotion.
    // https://emotion.sh/docs/css-prop#style-precedence
    ,
    className: props.className
    /* ARIA */
    ,
    "aria-readonly": props.isReadOnly,
    "aria-multiline": "true",
    role: "textbox",
    minRows: MIN_ROW_COUNT,
    maxRows: props.isOpen ? undefined : MIN_ROW_COUNT,
    cacheMeasurements: true
  }, filterDataAttributes(props)));
};

MultilineInput.propTypes = process.env.NODE_ENV !== "production" ? {
  autoComplete: _pt.string,
  className: _pt.string,
  hasError: _pt.bool,
  hasWarning: _pt.bool,
  id: _pt.string,
  isAutofocussed: _pt.bool,
  isDisabled: _pt.bool,
  isReadOnly: _pt.bool,
  name: _pt.string,
  onBlur: _pt.func,
  onChange: _pt.func,
  onFocus: _pt.func,
  placeholder: _pt.string,
  value: _pt.string.isRequired,
  isOpen: _pt.bool.isRequired,
  onHeightChange: _pt.func
} : {};
MultilineInput.displayName = 'MultilineInput';
var MultilineInput$1 = MultilineInput;
var messages = defineMessages({
  expand: {
    id: 'UIKit.MultilineTextInput.expand',
    description: 'The label for "expand" action',
    defaultMessage: 'Expand'
  },
  collapse: {
    id: 'UIKit.MultilineTextInput.collapse',
    description: 'The label for "collapse" action',
    defaultMessage: 'Collapse'
  }
});

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var accessibleHiddenInputStyles = process.env.NODE_ENV === "production" ? {
  name: "fkeaox",
  styles: "pointer-events:none;height:100%;left:0;opacity:0.0001;position:absolute;top:0;width:100%"
} : {
  name: "vekel6-accessibleHiddenInputStyles",
  styles: "pointer-events:none;height:100%;left:0;opacity:0.0001;position:absolute;top:0;width:100%;label:accessibleHiddenInputStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFjY2Vzc2libGUtaGlkZGVuLWlucHV0LnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFdUMiLCJmaWxlIjoiYWNjZXNzaWJsZS1oaWRkZW4taW5wdXQuc3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5jb25zdCBhY2Nlc3NpYmxlSGlkZGVuSW5wdXRTdHlsZXMgPSBjc3NgXG4gIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICBoZWlnaHQ6IDEwMCU7XG4gIGxlZnQ6IDA7XG4gIG9wYWNpdHk6IDAuMDAwMTtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDA7XG4gIHdpZHRoOiAxMDAlO1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgYWNjZXNzaWJsZUhpZGRlbklucHV0U3R5bGVzO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var accessibleHiddenInputStyles$1 = accessibleHiddenInputStyles; // NOTE: This string will be replaced on build time with the package version.

var version = "12.2.9";
export { LocalizedInputToggle$1 as LocalizedInputToggle, MultilineInput$1 as MultilineInput, accessibleHiddenInputStyles$1 as accessibleHiddenInputStyles, getInputStyles, messages$1 as messagesLocalizedInput, messages as messagesMultilineInput, version };